import Service from "common/Layout/Article/Service";
import Redirect from "Components/Redirect";
import type {
  GetServerSideProps,
  InferGetServerSidePropsType,
  NextPage,
} from "next";
import {
  fetchLayoutData,
  fetchSectionData,
  renderPublication,
} from "../../../../lib";
import { setHeaders } from "../../../common/Utils/headers";

const ServiceArticle: NextPage = ({
  data,
  menus,
}: InferGetServerSidePropsType<typeof getServerSideProps>) => {
  if (!data) {
    return <Redirect destination={"/"} />;
  }
  if (data?.data?.type === "redirect") {
    return <Redirect destination={data?.data?.destination} />;
  }
  return <Service article={data} menus={menus} />;
};

export default ServiceArticle;

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { res, req } = context;
  setHeaders(req, res);
  const publication = renderPublication(context.req);

  try {
    const props = {
      data: await fetchSectionData(
        publication,
        `?path=service/${context.params?.service_id}`
      ),
      menus: await fetchLayoutData(publication),
      publication,
    };
    return {
      props,
    };
  } catch (err) {
    console.log(err);
  }

  return { props: { data: "err" } };
};
